/**
 * Shared constants and utility functions for influencers
 */

export const CATEGORIES = [
  'lifestyle', 'fashion', 'beauty', 'travel', 'tech', 
  'fitness', 'food', 'parenting', 'gaming', 'entertainment',
  'education', 'business', 'other'
];

/**
 * Calculates influencer tier based on follower count
 * @param {number} followers 
 * @returns {string} tier name
 */
export const calculateTier = (followers) => {
  if (followers < 10000) return 'nano';
  if (followers < 50000) return 'micro';
  if (followers < 200000) return 'mid';
  if (followers < 1000000) return 'macro';
  return 'mega';
};
